import { MutationTree } from "vuex";
import { Nomenclature } from "@/types";
import { IDataProvider } from "@/store";
import { INomenclatureState } from "@/store/modules/nomenclature/state";

export enum NomenclatureMutations {
  SET_ONE = "SET_ONE_NOMENCLATURE",
  SET_ALL = "SET_ALL_NOMENCLATURE",
  SET_LAZY_DATA = "SET_LAZY_DATA_NOMENCLATURE",
}

export const mutations: MutationTree<INomenclatureState> = {
  [NomenclatureMutations.SET_ONE](state, payload: Nomenclature) {
    state.nomenclature = payload;
  },
  [NomenclatureMutations.SET_ALL](state, payload: Nomenclature[]) {
    state.nomenclatures = payload;
  },
  [NomenclatureMutations.SET_LAZY_DATA](
    state,
    payload: IDataProvider<Nomenclature>
  ) {
    state.dataProvider = payload;
  },
};
